
export class AdminSearchResultsModel {

  licenseNumber: number;
  businessName: string;

  /**
   * Converts JSON representation of search results into {@link AdminSearchResultsModel} instance.
   *
   * @param jsonObject JSON representation of search result
   */
  static fromJSON(jsonObject: any): AdminSearchResultsModel {
    const result = Object.create(AdminSearchResultsModel.prototype);
    return Object.assign(result, jsonObject, {
      licenseNumber: jsonObject.licenseNumber ? jsonObject.licenseNumber : null,
      businessName: jsonObject.businessName ? jsonObject.businessName : null
    });
  }

}
